export { default } from './CenteredContent';
